import ActionTypes from "../../../constants";
import {} from "../types";
import { BusinessPartnerType } from "../../BusinessPartnerDetails/types";

export const fetchRejectedBP = payload => ({
  type: ActionTypes.FETCH_REJECTED_BUSINESS_PARTNERS,
  payload
});

export const fetchRejectedBPSucceeded = (rejectedBPlist, pageInfo) => ({
  type: ActionTypes.FETCH_REJECTED_BUSINESS_PARTNERS_SUCCEEDED,
  rejectedBPlist,
  pageInfo
});
